const config = {
  ENVIRONMENT_NAME: 'testing',
  forwoodId: {
    URL: 'https://id.testing.eurecovery.forwoodsafety.com',
    USER_TOKEN_URL: 'https://c3e8ob0i8f.execute-api.eu-west-1.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'eu-west-1',
    URL: 'https://cpu25bbde4.execute-api.eu-west-1.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'teams-container-1.11.5',
    HOSTNAME: 'https://teams.testing.eurecovery.forwoodsafety.com',
    TEAMS_MICROFRONTEND_URL: 'https://teams-service.testing.eurecovery.forwoodsafety.com',
    TARGETS_MICROFRONTEND_URL: 'https://targets.testing.eurecovery.forwoodsafety.com',
    TEAMS_ACCESS_ROLE: 'TeamsAccess',
    TEAM_TARGETS_ACCESS_ROLE: 'TeamTargetsAccess',
  },
  configurationService: {
    URL: 'https://config.testing.eurecovery.forwoodsafety.com',
    WEBSOCKET: 'wss://mx3s7li7i2.execute-api.eu-west-1.amazonaws.com/testing'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
